import { render } from "./ReturnVisitRate.vue?vue&type=template&id=3b1c976f"
import script from "./ReturnVisitRate.vue?vue&type=script&lang=js"
export * from "./ReturnVisitRate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__